module.exports = __webpack_public_path__ + "img/hon_hoac_bang.39fffb0b.svg";